import useAuth from '@rhg/libs/auth0/use-auth';
import { queryKeys } from '@rhg/libs/react-query';
import {
    ppDataObject,
    JwtPayload,
    PartnerPortalData,
    getIsSamlUserToken,
} from '@rhg/utils/sso';
import { useQuery } from '@tanstack/react-query';
import { jwtDecode } from 'jwt-decode';

export function useTokenData() {
    const { user, isLoading, getAccessTokenSilently } = useAuth();
    const { data, ...otherProps } = useQuery({
        queryKey: [queryKeys.tokenData],
        queryFn: async () => {
            return getTokenData(await getAccessTokenSilently());
        },
        enabled: !isLoading && !!user,
    });

    return {
        ...data,
        ...otherProps,
    };
}

export function getTokenData(token?: string) {
    if (!token) {
        return null;
    }
    const decodedToken = jwtDecode(token) as JwtPayload;
    const tokenPartnerPortalData = decodedToken[
        ppDataObject
    ] as PartnerPortalData;
    return {
        token,
        decodedToken,
        tokenPartnerPortalData,
        isSaml: getIsSamlUserToken(decodedToken),
    };
}
